import { render, staticRenderFns } from "./ContentNotesEditor.vue?vue&type=template&id=98fbf84a"
import script from "./ContentNotesEditor.vue?vue&type=script&lang=js"
export * from "./ContentNotesEditor.vue?vue&type=script&lang=js"
import style0 from "./ContentNotesEditor.vue?vue&type=style&index=0&id=98fbf84a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports